<template>
  <div>
    <b-card-group deck>
      <b-card title="Seleccione opcion de busqueda" class="text-uppercase text-center">
        <b-col>
          <b-form-select
            @change="setData($event)"
            v-model="selected"
            :options="options"
            class="mb-3"
          />
        </b-col>
      </b-card>
      <b-card
        title="Documento de usuario a buscar"
        class="text-uppercase text-center"
        v-if="selected==1"
      >
        <b-col>
          <b-form-input
            @change="searchId()"
            id="input-default"
            v-model="idSearch"
            type="text"
            placeholder="Documento"
          ></b-form-input>
        </b-col>
      </b-card>
      <b-card
        title="Documento de usuario a buscar"
        class="text-uppercase text-center"
        v-if="selected==2"
      >
        <b-col>
          <qrcode-reader v-if="mostrar" @decode="onDecode"></qrcode-reader>
        </b-col>
      </b-card>
    </b-card-group>
  </div>
</template>
<script>
export default {
  name: "validate",
  components: {},
  data: function() {
    return {
      modalShow: true,
      selected: null,
      idSearch: "",
      mostrar: true,
      options: [
        {
          value: null,
          text: "Seleccione validacion de credencial"
        },
        {
          value: 1,
          text: "Mediante codigo"
        },
        {
          value: 2,
          text: "Mediante QR"
        }
      ]
    };
  },
  methods: {
    setData: function(select) {
      console.log(select);
    },
    searchId: function() {
      console.log(this.idSearch);
      this.$store
        .dispatch("validateCredential", this.idSearch)
        .then(response => {
          console.log("respuesta", response);
        })
        .catch(err => {
          console.log("respuesta", err);
        });
    },
    onDecode: function(decode) {
      this.mostrar = false; 
      if (decode.length > 2) {
        let resp = this.$store.dispatch("validateCredential", decode);
        console.log("respuesta", resp);
        if (resp.code === 2) {
          this.$router.push({
            path: "cafeteria/requests/list"
          });
        }
      }else{
        setTimeout(()=>{
          this.mostrar = true; 
        },200);
      
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/requests/validate.vue